import { ShimmerLayout, ShimmerRow } from "components/ShimmerRow/shimmer";
import React from "react";


export const ShippingAddressLoader = () => (
  <div className="prl15 mb10 full-wrap existing-customer-shipping bottom-fix-space default-address-loader-container">
    <header className="header-action">
      <ShimmerLayout className="layout horizontal justified center wrap ">
        <ShimmerRow margin="15px 8px 0px 8px" width="100%" height="174px" />
      </ShimmerLayout>

    </header>
  </div>
);
